import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

// Capacitor
import { Browser } from "@capacitor/browser";

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {

  username;
  email;
  emailCheck;
  password;
  passwordCheck;
  privacyPolicyAccepted = false;
  personalizedAdAccepted = false;

  validationMessages = {
    username: null,
    email: null,
    emailCheck: null,
    password: null,
    passwordCheck: null,
    privacyPolicyAccepted: null
  };

  constructor(
    private userService: UserService,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private router: Router
  ) { }

  ngOnInit() { }

  async register(keyCode?) {
    if (!!keyCode === false || keyCode === 13) {
      const validateResult = this.validate();
      if (!!validateResult === false) { return; }

      const loading = await this.loadingController.create({ message: 'Operazione in corso...' });
      loading.present();

      // Validation passed. Make registration
      const registerResponse = await this.userService.register({
        name: this.username,
        email: this.email,
        password: this.password,
        privacy_policy_accepted: this.privacyPolicyAccepted,
        personalized_ad_accepted: this.personalizedAdAccepted
      });

      console.log({ registerResponse });

      // Check for server error
      if (!!registerResponse.error) {
        switch (registerResponse.message) {
          case 'user-email-already-exists':
            this.validationMessages.email = `L'email che hai inserito è già registrata!`;
            break;
          case 'user-name-already-exists':
            this.validationMessages.username = `Il nickname che hai scelto non è disponibile.`;
            break;
          default:
            this.alertController.create({ header: 'Ci dispiace!', message: 'Qualcosa non è andata a buon fine durante la registrazione. Ti preghiamo di riprovare tra poco.' });
            break;
        }
        await loading.dismiss();
        return;
      }

      // Registration was completed
      await loading.dismiss();
      const alert = await this.alertController.create({
        header: 'Complimenti fantallenatore!',
        message: 'La community di Fantaballottaggi ti dà il benvenuto!',
        buttons: [{
          text: 'OK',
          role: 'confirm',
          handler: async () => {
            await this.router.navigate(['/home']);
          }
        }]
      });
      await alert.present();
    }
  }

  validate() {
    this.resetValidationMessages();
    return this.validateEmail()
        && this.validateEmailCheck()
        && this.validatePassword()
        && this.validatePasswordCheck()
        && this.validatePrivacy();
  }

  resetValidationMessages() {
    Object.keys(this.validationMessages).forEach((key) => {
      this.validationMessages[key] = null;
    });
  }

  validateEmail() {
    const expression = RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$');
    if (expression.test(this.email)) {
      return true;
    }
    this.validationMessages.email = 'Assicurati di inserire una email valida';
    return false;
  }

  validateEmailCheck() {
    if (this.email === this.emailCheck) {
      return true;
    }
    this.validationMessages.emailCheck = 'Email di conferma non corrispondente';
    return false;
  }

  validatePassword() {
    // Check if is empty
    if (!!this.password === false) {
      this.validationMessages.password = 'Per la tua sicurezza è necessario inserire una password.';
      return false;
    }

    // Check if is strong enough
    // const strongExpression = RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
    const expression = RegExp('^(?=.*[0-9])(?=.{8,})');
    if (expression.test(this.password) === false) {
      this.validationMessages.password = `La password deve avere almeno 8 caratteri e contenere lettere e almeno un numero.`;
      return false;
    }

    return true;
  }

  validatePasswordCheck() {
    if (this.password === this.passwordCheck) {
      return true;
    }
    this.validationMessages.passwordCheck = 'Password di conferma non corrispondente';
    return false;
  }

  validatePrivacy() {
    // Check if is false
    if (!!this.privacyPolicyAccepted === false) {
      this.validationMessages.privacyPolicyAccepted = 'Per usare l\'app è obbligatorio accettare la nostra politica sulla privacy.';
      return false;
    }
    return true;
  }

  async goToHome() {
    await this.router.navigate(['/home']);
  }

  async openPrivacyPolicyUrl() {
    await Browser.open({ url: environment.privacyPolicyUrl });
  }

  async openTermsAndConditionsUrl() {
    await Browser.open({ url: environment.termsAndConditionsUrl });
  }

}
